// extracted by mini-css-extract-plugin
module.exports = {"tab-section-title":"styles__tab-section-title__2UTz-","tabSectionTitle":"styles__tab-section-title__2UTz-"};